// tslint:disable
import {injectGlobal} from 'emotion';

injectGlobal`
@font-face {
  font-family: 'anticon';
  src: url('https://at.alicdn.com/t/font_148784_v4ggb6wrjmkotj4i.eot');
  src: url('https://at.alicdn.com/t/font_148784_v4ggb6wrjmkotj4i.woff') format('woff'),
  url('https://at.alicdn.com/t/font_148784_v4ggb6wrjmkotj4i.ttf') format('truetype'),
  url('https://at.alicdn.com/t/font_148784_v4ggb6wrjmkotj4i.svg#iconfont') format('svg');
}
`;



// WEBPACK FOOTER //
// ./src/components/Icon/private/injectIconFonts.ts